import {createContext} from 'react'

const SurveyContext = createContext()

export default SurveyContext
